import { isOutOfWinchLimit } from './formatWinchValue';

interface MeasurementLimits {
    min: number;
    max: number;
}

interface MeasurementValues {
    distance: number | null;
    depth: number | null;
    minDepth: number | null;
    maxDepth: number | null;
}

interface MeasurementFieldMessages {
    distance: string;
    depth: string;
    scanOrder: string;
}

export interface MeasurementFieldErrors {
    distanceError?: string;
    depthError?: string;
    minError?: string;
    maxError?: string;
}

function rangeError(
    value: number | null,
    limits: MeasurementLimits,
    message: string
): string | undefined {
    if (value == null) {
        return undefined;
    }
    return isOutOfWinchLimit(value, limits.min, limits.max) ? message : undefined;
}

export function measurementFieldErrors(
    values: MeasurementValues,
    scanEnabled: boolean,
    distanceLimits: MeasurementLimits,
    depthLimits: MeasurementLimits,
    messages: MeasurementFieldMessages
): MeasurementFieldErrors {
    const scanOrderError =
        scanEnabled &&
        values.minDepth != null &&
        values.maxDepth != null &&
        values.minDepth >= values.maxDepth
            ? messages.scanOrder
            : undefined;

    return {
        distanceError: rangeError(values.distance, distanceLimits, messages.distance),
        depthError: scanEnabled ? undefined : rangeError(values.depth, depthLimits, messages.depth),
        minError: scanEnabled
            ? (rangeError(values.minDepth, depthLimits, messages.depth) ?? scanOrderError)
            : undefined,
        maxError: scanEnabled
            ? (rangeError(values.maxDepth, depthLimits, messages.depth) ?? scanOrderError)
            : undefined,
    };
}
